var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSinglechoice = function SvgSinglechoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.5 51"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".singlechoice_svg__abc{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "singlechoice_svg__bdfdad9d-e824-4487-8add-7375d0eb0bf9",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "singlechoice_svg__edb4e9ab-ce1d-4d0f-a003-2d861bcfe2b4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.5H58",
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 25.5,
    r: 5,
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25.5H58",
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 45.5,
    r: 5,
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 45.5H58",
    className: "singlechoice_svg__abc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 25.5,
    r: 3,
    className: "singlechoice_svg__abc"
  })))));
};
export { SvgSinglechoice as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OC41IDUxIj4KICAgIDxkZWZzPgogICAgICAgIDxzdHlsZSBzdHlsZT0idGV4dC9jc3MiPi5hYmN7ZmlsbDpub25lO3N0cm9rZTojMDAwMDAwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9PC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJiZGZkYWQ5ZC1lODI0LTQ0ODctOGFkZC03Mzc1ZDBlYjBiZjkiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICAgICAgPGcgaWQ9ImVkYjRlOWFiLWNlMWQtNGQwZi1hMDAzLTJkODYxYmNmZTJiNCIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgICAgICAgICAgPGNpcmNsZSBjbGFzcz0iYWJjIiBjeD0iNS41IiBjeT0iNS41IiByPSI1Ii8+CiAgICAgICAgICAgIDxsaW5lIGNsYXNzPSJhYmMiIHgxPSIyMC41IiB5MT0iNS41IiB4Mj0iNTgiIHkyPSI1LjUiLz4KICAgICAgICAgICAgPGNpcmNsZSBjbGFzcz0iYWJjIiBjeD0iNS41IiBjeT0iMjUuNSIgcj0iNSIvPgogICAgICAgICAgICA8bGluZSBjbGFzcz0iYWJjIiB4MT0iMjAuNSIgeTE9IjI1LjUiIHgyPSI1OCIgeTI9IjI1LjUiLz4KICAgICAgICAgICAgPGNpcmNsZSBjbGFzcz0iYWJjIiBjeD0iNS41IiBjeT0iNDUuNSIgcj0iNSIvPgogICAgICAgICAgICA8bGluZSBjbGFzcz0iYWJjIiB4MT0iMjAuNSIgeTE9IjQ1LjUiIHgyPSI1OCIgeTI9IjQ1LjUiLz4KICAgICAgICAgICAgPGNpcmNsZSBjbGFzcz0iYWJjIiBjeD0iNS41IiBjeT0iMjUuNSIgcj0iMyIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";